import { render, staticRenderFns } from "./RateArrangement.vue?vue&type=template&id=796576a1&scoped=true&"
import script from "./RateArrangement.vue?vue&type=script&lang=js&"
export * from "./RateArrangement.vue?vue&type=script&lang=js&"
import style0 from "./RateArrangement.vue?vue&type=style&index=0&id=796576a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796576a1",
  null
  
)

export default component.exports